<template>
  <div>
    <b-row class="d-flex justify-content-between align-items-center ">
      <!-- Фильтр по тип  -->
      <b-col
        v-if="types"
        class="mb-1"
      >
        <h6>
          <strong>Тип</strong>
        </h6>
        <div class="pb-50">
          <b-form-checkbox
            v-model="filtered.type"
            value="income"
            class="custom-control-primary"
          >
            Поступление
          </b-form-checkbox>
        </div>
        <div class="pb-50">
          <b-form-checkbox
            v-model="filtered.type"
            value="expense"
            class="custom-control-primary"
          >
            Выплата
          </b-form-checkbox>
        </div>
        <!-- <div>
          <b-form-checkbox
            value="A"
            class="custom-control-primary"
          >
            Перемещение
          </b-form-checkbox>
        </div> -->
        <hr>
      </b-col>

      <!-- Поиск: -->
      <b-col
        v-if="search"
        sm="6"
        md="4"
        lg="4"
      >
        <b-form-group
          :label="$t('generals.search')"
          label-for="search"
        >
          <b-input-group
            :label="$t('generals.search')"
            label-for="search"
          >
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="search"
              v-model="filtered.search"
              :placeholder="$t('generals.search') + '...'"
              @input="emitFiltered"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Фильтр по Счет -->
      <b-col
        v-if="finance"
        sm="6"
        md="4"
        lg="12"
      >
        <b-form-group
          label-for="filterIncomeCashbox"
        >
          <h6>
            <strong> {{ $t('finance.cash_box') }} </strong>
          </h6>
          <v-select
            id="filterIncomeCashbox"
            v-model="filtered.income_cashbox"
            label="title"
            :options="optionIncomeCashbox"
            :reduce="group => group.id"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <b-col
        v-if="finance"
        sm="6"
        md="4"
        lg="12"
      >
        <b-form-group
          label-for="filterPaymentType"
        >
          <h6>
            <strong> {{ $t('finance.payment_type') }} </strong>
          </h6>
          <v-select
            id="filterPaymentType"
            v-model="filtered.payment_type"
            :options="payment_type_options"
            :get-option-label="opt => opt.title[$i18n.locale]"
            :reduce="opt => opt.value"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <b-col
        v-if="income_type"
        sm="6"
        md="4"
        lg="12"
      >
        <b-form-group
          label-for="filterContract"
        >
          <h6>
            <strong> {{ $t('finance.income_type') }} </strong>
          </h6>
          <v-select
            id="filterIncomeType"
            v-model="filtered.income_type"
            :get-option-label="type => type.title[$i18n.locale]"
            :options="income_type_options"
            :reduce="type => type.value"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <!-- Фильтр по Контракт -->
      <b-col
        v-if="contract"
        sm="6"
        md="4"
        lg="12"
      >
        <b-form-group
          label-for="filterContract"
        >
          <h6>
            <strong> {{ $t('clients.contract') }} </strong>
          </h6>
          <v-select
            id="filterContract"
            v-model="filtered.contract"
            label="contract_number"
            :options="optionContract"
            :reduce="group => group.id"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <!-- Фильтр по Статья -->
      <!-- <b-col
        v-if="finance"
        sm="6"
        md="4"
        lg="12"
      >
        <b-form-group
          label="Статья"
          label-for="filterCostItem"
        >
          <v-select
            id="filterCostItem"
            v-model="filtered.cost_item"
            label="name"
            :options="optionCostItem"
            :reduce="group => group.id"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col> -->

      <!-- Дата рождения с -->
      <b-col
        v-if="date || finance"
        sm="6"
        md="4"
        lg="12"
      >
        <b-form-group
          label-for="birthdayStart"
        >
          <h6>
            <strong> {{ $t('finance.date') }} </strong>
          </h6>

          <flat-pickr
            id="birthdayStart"
            v-model="filtered.paid_at"
            class="form-control"
            :placeholder="$t('finance.date')"
            @input="emitFiltered"
          />
          <!-- <datepicker
            :bootstrap-styling="true"
            :clear-button="true"
            :language="ru"
            :calendar-button="true"
            format="dd.MM.yyyy"
            calendar-button-icon="fa fa-calendar"
            clear-button-icon="fa fa-times"
            input-class="bg-white"
          /> -->
        </b-form-group>
      </b-col>

      <!-- Дата рождения с -->
      <b-col
        v-if="charts"
        sm="6"
        md="4"
        lg="3"
      >
        <b-form-group
          :label="$t('finance.from_date')"
          label-for="birthdayStart"
        >
          <datepicker
            id="birthdayStart"
            v-model="start_date"
            :bootstrap-styling="true"
            :clear-button="true"
            :language="ru"
            :calendar-button="true"
            :placeholder="$t('finance.date')"
            minimum-view="month"
            format="MMM yyyy"
            calendar-button-icon="fa fa-calendar"
            clear-button-icon="fa fa-times"
            input-class="bg-white"
            @selected="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <!-- Дата рождения по -->
      <b-col
        v-if="charts"
        sm="6"
        md="4"
        lg="3"
      >
        <b-form-group
          :label="$t('finance.to_date')"
          label-for="birthdayEnd"
        >
          <datepicker
            id="birthdayEnd"
            v-model="end_date"
            :bootstrap-styling="true"
            :clear-button="true"
            :language="ru"
            :calendar-button="true"
            :placeholder="$t('finance.date')"
            input-class="bg-white"
            minimum-view="month"
            format="MMM yyyy"
            calendar-button-icon="fa fa-calendar"
            clear-button-icon="fa fa-times"
            @selected="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <!-- Дата рождения по -->
      <b-col
        v-if="yearCharts"
        sm="6"
        md="4"
        lg="3"
      >
        <b-form-group
          :label="$t('finance.year')"
          label-for="birthdayEnd"
        >
          <datepicker
            id="birthdayEnd"
            v-model="filtered.year"
            :bootstrap-styling="true"
            :clear-button="true"
            :language="ru"
            :calendar-button="true"
            :placeholder="$t('finance.year')"
            input-class="bg-white"
            minimum-view="year"
            format="yyyy"
            calendar-button-icon="fa fa-calendar"
            clear-button-icon="fa fa-times"
            @selected="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <!-- Фильтр по роли -->
      <b-col
        v-if="roles"
        sm="6"
        md="4"
        lg="3"
      >
        <b-form-group
          label="Фильтр по роли"
          label-for="filterRols"
        >
          <v-select
            id="filterRols"
            v-model="filtered.selectedRoles"
            label="name"
            :options="optionRoles"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <!-- Фильтр по группе -->
      <b-col
        v-if="group"
        sm="6"
        md="4"
        lg="3"
      >
        <b-form-group
          :label="$t('administration.filter_by_group')"
          label-for="filterGroup"
        >
          <v-select
            id="filterGroup"
            v-model="filtered.child_class"
            label="title"
            :placeholder="$t('administration.filter_by_group')"
            :options="optionGroup"
            :reduce="group => group.id"
            @input="getSubgroup"
          />
        </b-form-group>
      </b-col>

      <!-- Фильтр по подгруппе -->
      <b-col
        v-if="subgroup"
        sm="6"
        md="4"
        lg="3"
      >
        <b-form-group
          :label="$t('administration.filter_by_subgroup')"
          label-for="filterSubgroup"
        >
          <v-select
            id="filterSubgroup"
            v-model="filtered.child_groups"
            label="title"
            :disabled="!filtered.child_class"
            :placeholder="$t('administration.filter_by_subgroup')"
            :reduce="subgroup => subgroup.id"
            :options="optionSubgroup"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col>
      <!-- Фильтр по статистике -->
      <b-col
        v-if="statistics"
        sm="6"
        md="4"
        lg="3"
      >
        <b-form-group
          :label="$t('administration.filter_by_statistics')"
          label-for="filterStatistics"
        >
          <v-select
            id="filterStatistics"
            v-model="filtered.selectedStatistics"
            label="title"
            :options="optionStatistics"
            @input="emitFiltered"
          />
        </b-form-group>
      </b-col>

      <!-- Добавить -->
      <b-col
        v-if="add"
        class="text-right"
        lg="2"
      >
        <b-button
          variant="info"
          @click="addButtonEmit"
        >
          {{ $t('generals.add') }}
          <!--Добавить button-->
        </b-button>
      </b-col>

      <!-- Очистит -->
      <b-col
        v-if="clear"
        class="text-right"
        lg="2"
      >
        <b-button
          variant="outline-warning"
          @click="clearData"
        >
          {{ $t('generals.clear') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {
  BRow, BCol, BFormGroup, BFormInput, BButton, BInputGroupPrepend, BInputGroup, BFormCheckbox,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Datepicker from 'vuejs-datepicker'
import { ru } from 'vuejs-datepicker/dist/locale'
import { mapActions } from 'vuex'

export default {
  name: 'Filters',
  components: {
    vSelect,
    flatPickr,
    Datepicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
  },
  props: {
    add: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: true,
    },
    date: {
      type: Boolean,
      default: false,
    },
    finance: {
      type: Boolean,
      default: false,
    },
    charts: {
      type: Boolean,
      default: false,
    },
    roles: {
      type: Boolean,
      default: false,
    },
    optionRoles: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Boolean,
      default: false,
    },
    contract: {
      type: Boolean,
      default: false,
    },
    optionContract: {
      type: Array,
      default: () => [],
    },
    optionGroup: {
      type: Array,
      default: () => [],
    },
    subgroup: {
      type: Boolean,
      default: false,
    },
    optionSubgroup: {
      type: Array,
      default: () => [],
    },
    statistics: {
      type: Boolean,
      default: false,
    },
    optionStatistics: {
      type: Array,
      default: () => [],
    },
    optionCostItem: {
      type: Array,
      default: () => [],
    },
    optionIncomeCashbox: {
      type: Array,
      default: () => [],
    },
    types: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
    yearCharts: {
      type: Boolean,
      default: false,
    },
    income_type: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ru,
      timeOut: null,
      start_date: null,
      end_date: null,
      filtered: {
        paid_at: null,
        contract: null,
        year: '',
        search: '',
        selectedRoles: null,
        child_class: null,
        child_groups: null,
        selectedStatistics: null,
        income_cashbox: null,
        payment_type: null,
        cost_item: null,
        type: null,
      },
      income_type_options: [
        {
          title: {
            ru: 'Продажа',
            uz: 'Sotuv',
          },
          value: 'sale',
        },
        {
          title: {
            ru: 'Дебитор',
            uz: 'Debitor',
          },
          value: 'debtor',
        },
      ],
      payment_type_options: [{
        title: {
          ru: 'Банк',
          uz: 'Bank',
        },
        value: 'cash',
      },
      {
        title: {
          ru: 'Счет',
          uz: 'Hisob',
        },
        value: 'noncash',
      },
      {
        title: {
          ru: 'Бартер',
          uz: 'Barter',
        },
        value: 'barter',
      }],
    }
  },
  methods: {
    ...mapActions('administration', [
      'FETCH_SELECT_SUBGROUP_LIST',
    ]),
    emitFiltered() {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        if (!this.filtered.paid_at) {
          this.filtered.paid_at = null
        }
        if (this.start_date) {
          this.filtered.start_date = this.start_date.toLocaleDateString()
        } else {
          this.filtered.start_date = null
        }
        if (this.end_date) {
          this.filtered.end_date = this.end_date.toLocaleDateString()
        } else {
          this.filtered.end_date = null
        }
        if (!this.filtered.search) {
          this.filtered.search = null
        }
        if (!this.filtered.type) {
          this.filtered.type = null
        }
        if (!this.filtered.contract) {
          this.filtered.contract = null
        }
        if (!this.filtered.year) {
          this.filtered.year = null
        }
        this.$emit('filtered-items', this.filtered)
        console.log('this.filtered', this.filtered)
      }, 600)
    },
    getSubgroup() {
      if (this.filtered.child_class) {
        this.FETCH_SELECT_SUBGROUP_LIST({ class_name: this.filtered.child_class })
        this.emitFiltered()
      } else {
        this.filtered.child_groups = null
        this.emitFiltered()
      }
    },
    addButtonEmit() {
      this.$emit('add-button-clicked')
    },
    clearData() {
      this.filtered = {
        selectedRoles: null,
        paid_at: null,
        child_class: null,
        child_groups: null,
        selectedStatistics: null,
        income_cashbox: null,
        cost_item: null,
        type: null,
        contract: null,
      }
      this.emitFiltered()
    },
  },
  watch: {
    'filtered.type': {
      handler() {
        this.emitFiltered()
      },
    },
    // paid_at() {
    //   this.emitFiltered()
    // },
  },
}
// Object.keys(obj).forEach((k) => obj[k] == null && delete obj[k])
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.v-select, .v-select * {
  background: #fff;
}
</style>
